var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 12.6667V7.33334H15.3332V12.6667H20.6665V15.3333H15.3332V20.6667H12.6665V15.3333H7.33317V12.6667H12.6665ZM13.9998 27.3333C6.63584 27.3333 0.666504 21.364 0.666504 14C0.666504 6.63601 6.63584 0.666672 13.9998 0.666672C21.3638 0.666672 27.3332 6.63601 27.3332 14C27.3332 21.364 21.3638 27.3333 13.9998 27.3333ZM13.9998 24.6667C16.8288 24.6667 19.5419 23.5429 21.5423 21.5425C23.5427 19.5421 24.6665 16.829 24.6665 14C24.6665 11.171 23.5427 8.45792 21.5423 6.45753C19.5419 4.45714 16.8288 3.33334 13.9998 3.33334C11.1709 3.33334 8.45775 4.45714 6.45737 6.45753C4.45698 8.45792 3.33317 11.171 3.33317 14C3.33317 16.829 4.45698 19.5421 6.45737 21.5425C8.45775 23.5429 11.1709 24.6667 13.9998 24.6667Z",
    fill: "#1B75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.3f05446255669f2d3407fe7169449684.svg";
export { ForwardRef as ReactComponent };